export default __webpack_public_path__ + "static/media/rk5.ea085837.png";